export default __webpack_public_path__ + "static/media/BITWA_2.8d7c22b9.gif";